export const rangeColors = {
  main: 'seaBlue.28',
  track: 'sandstone.79',
  disabled: 'sandstone.55',
} as const
